module.exports = __webpack_public_path__ + "img/symbol-hand-left.c0d8b3fe.png";